svg4everybody();

$('.header__search-link').on('click', function() {
    $(this).toggleClass('focus');
    $(this).siblings('.header__search-form').toggleClass('expanded');
    $(this).siblings('.header__search-form').find('input').focus();
    return false;
});

$('.sidemenu__menu-link.has-child').on('click', function() {
    var _trigger = $(this);
    var _triggerParent = $(this).parents('.sidemenu__menu-item');
    _triggerParent.toggleClass('open');
    $('.sidemenu__menu-link.has-child').not(_trigger).parents('.sidemenu__menu-item').removeClass('open');
    return false;
});

$('.header__hamburger').on('click', function() {
    $('.sidemenu').addClass('open');
    $('body').addClass('sidemenu-shown sidemenu-shown compensate-for-scrollbar');
    return false;
});

$('.sidemenu__close-trigger').on('click', function() {
    $('.sidemenu').removeClass('open');
    $('body').removeClass('sidemenu-shown compensate-for-scrollbar');
    return false;
});

$('.js-application-trigger').on('click', function() {
    var _this = $(this);
    _this.toggleClass('open');
    _this.siblings('.js-calculator-trigger').removeClass('open');
    var _parent = $(this).parents('.page__app-and-calc');
    _parent.siblings('.js-application-widget').slideToggle();
    _parent.siblings('.js-calculator-widget').slideUp();
    return false;
});

$('.js-calculator-trigger').on('click', function() {
    var _this = $(this);
    _this.toggleClass('open');
    _this.siblings('.js-application-trigger').removeClass('open');
    var _parent = $(this).parents('.page__app-and-calc');
    _parent.siblings('.js-calculator-widget').slideToggle();
    _parent.siblings('.js-application-widget').slideUp();
    return false;
});

$('[data-youtube-id]').youtubeCoverPhoto({
    useMaxRes: true
});

(function(){
    var setupStickyHeader = function() {
        var _headerHeight = $('.header').height();
        var _checkScrollPosition = $(window).scrollTop() > _headerHeight;
        $('.header').toggleClass('scrolled', _checkScrollPosition);
    }
    
    $(window).on('scroll', function() { setupStickyHeader(); });
    setupStickyHeader();
})();

$(".table").wrap("<div class='table-responsive'></div>");